<template>
  <div style="margin-bottom:25px">
    <vs-table pagination max-items="10" search stripe :data="branchSeries">
      <template slot="thead">
        <vs-th>Update Serial</vs-th>

        <vs-th sort-key="name">Branch</vs-th>
        <vs-th sort-key="lrstartno">Lr Start No</vs-th>
        <vs-th sort-key="lrendno">Lr End No</vs-th>
        <vs-th sort-key="lrcurrentno">Lr Current No</vs-th>
        <vs-th sort-key="freightstartno">Freight Start No</vs-th>
        <vs-th sort-key="freightendno">Freight Start No</vs-th>
        <vs-th sort-key="freightcurrentno">Freight Start No</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].lrSerialNoCnt">
            <vs-button
              v-if="data[indextr].lrSerialNoCnt > 0"
              @click="
                updateLrSeries(data[indextr].id, data[indextr].lrcurrentno)
              "
              >Update Lr No</vs-button
            >
          </vs-td>
          <vs-td :data="data[indextr].name">{{ data[indextr].name }} </vs-td>
          <vs-td :data="data[indextr].lrstartno"
            >{{ data[indextr].lrstartno }}
          </vs-td>
          <vs-td :data="data[indextr].lrendno"
            >{{ data[indextr].lrendno }}
          </vs-td>
          <vs-td :data="data[indextr].lrcurrentno">{{
            data[indextr].lrcurrentno
          }}</vs-td>

          <vs-td :data="data[indextr].freightstartno">{{
            data[indextr].freightstartno
          }}</vs-td>
          <vs-td :data="data[indextr].freightendno">{{
            data[indextr].freightendno
          }}</vs-td>
          <vs-td :data="data[indextr].freightcurrentno">{{
            data[indextr].freightcurrentno
          }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  components: {},
  methods: {
    updateLrSeries(id, serialNo) {
      console.log(id, serialNo);
      this.$http
        .post("portage/updateLrSeries", {
          id: id,
          lrseriesNo: serialNo + 1,
        })
        .then((response) => {
          console.log(response);
          this.getBranchSeries();
        });
    },
    getBranchSeries() {
      this.$http.get("portage/getbranchseries").then((response) => {
        console.log(response);
        this.branchSeries = response.data.data;
      });
    },
  },
  data() {
    return {
      localData: JSON.parse(localStorage.getItem("sstUnData")),
      branchSeries: [],
    };
  },
  beforeMount() {
    this.getBranchSeries();
  },
};
</script>

<style >
</style>
<style lang="scss">
.consignment-add-analytics {
  .vx-card__body {
    padding: 0.1rem;
  }
}

.consignment-manual-add .vx-card__body {
  padding: 1.8rem !important;
}
</style>